<template>
  <MglMap
    class="MapBox"
    :accessToken="accessToken"
    :mapStyle.sync="mapStyle"
    @load="onMapLoaded"
  />
</template>

<script>
import { MglMap } from 'vue-mapbox';
import mapboxgl from 'mapbox-gl';

// Avoid if we can.
// import 'mapbox-gl/dist/mapbox-gl.css'

export default {
  name: 'MapboxWrapper',
  components: {
    MglMap
  },
  data() {
    return {
      accessToken: 'pk.eyJ1Ijoiam91cm5leXdvcmtzIiwiYSI6ImNqZzNxbGdvcjBrd2UycXBxanZkMzhzcGUifQ.yMDX6GUP0BT_AaNH2C4diw', 
      mapStyle: 'mapbox://styles/journeyworks/cjpsep1bv01pa2rpb8kyhusq9',
    }
  },
  computed: {
    projects() {
      return this.$store.getters.getProjectList;
    },
    /**
     * Project Coordinates by Project Id
     */
    projectCoordinates() {
      let coordinates = {};
      this.projects.forEach((project) => {
        coordinates[project.id] = [ 
          project.location.lng, 
          project.location.lat 
        ];
      })
      return coordinates;
    },
    highlighted() {
      return this.$store.getters.getHighlightedProjectList;
    }
  },
  watch: {
    highlighted(newValue) {
      this.zoomToBounds({
        projectIds: newValue
      });
    }
  },
  methods: {

    // Zoom in on bounds set by coordinates related to array of project ids
    zoomToBounds({ projectIds }) {
      let coordinates = [];

      projectIds.forEach((id) => {
        coordinates.push(
          this.projectCoordinates[id]
        );
      });
      
      if (coordinates.length === 0) {
        return;
      }
      if (coordinates.length === 1) {
        this.$store.map.flyTo({
          center: [
              parseFloat(coordinates[0][0], 10),
              parseFloat(coordinates[0][1], 10)
          ],
          zoom: 14
        }); 
      } else {

        let bounds = coordinates.reduce(function(bounds, coord) {
          return bounds.extend(coord);
        }, new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

        this.$store.map.fitBounds(bounds, { 
          padding: { left: 100, right: 100, top: 100, bottom: 240 } 
        });
      }
    },

    /**
     * Takes an array as input and returns all unique pairs that can be created
     */ 
    uniquePairs(arra) {
      let result_set = [], 
        result;
      for(let x = 0; x < Math.pow(2, arra.length); x++) {
        result = [];
        let i = arra.length - 1; 
        do {
          if( (x & (1 << i)) !== 0){
            result.push(arra[i]);
          }
        }  while(i--);
        
        if (result.length == 2) {
          result_set.push(result);
        }
      }

      return result_set; 
    },


    onMapLoaded(event) {
      // Note: a reference to the map has to be stored in a non-reactive manner.
      this.$store.map = event.map;

      this.addGemeenteBorders();
      this.addProjectRelations();
      this.addProjectPoints();

      this.$store.map.on('click', this.checkForFeatureOnClick);

      // this.$store.dispatch('setHighlightedProjectList', {
      //   projects: ['recbXvrOYYw1eEhTS', 'rechgYWnp0j4fnZof']
      // })
      // this.zoomToBounds({
      //   projectIds: ['recbXvrOYYw1eEhTS', 'rechgYWnp0j4fnZof']
      // });
    },

    /**
     * Load an external geojson with gemeente area's
     */
    addGemeenteBorders() {
      this.$store.map.addSource('gemeenten-source', {
        type: 'geojson',
        data: '/gemeenten.geojson'
      });
      this.$store.map.addLayer({
        "id": "gemeenten",
        "type": "fill",
        "source": 'gemeenten-source',
        "layout": {
        },
        "paint": {
          "fill-opacity": 0.15
        },
        "filter": ['all', ['==', 'GM_NAAM', 'off']]
      });
    },

    /**
     * Add two project / verhaal points layers, one bright, one muted
     */
    addProjectPoints() {
      let projects = this.projects;
      if (projects.length === 0) {
        return
      }

      projects = projects.map(this.projectToMapBoxPointFeature);
      let layer = {
        "id": "verhalen_muted",
        "type": "circle",
        "source": {
            "type": "geojson",
            "data": {
                "type": "FeatureCollection",
                "features": projects
            }
        },
        "paint": {
            'circle-radius': 6,
            "circle-color": '#2da798',
            "circle-opacity": 0.6,
            "circle-stroke-width": 0,
        },
        "filter": ['==', 'type', 'off']
      };
      this.$store.map.addLayer(layer);

      // Add a second project dots layer, so we can highlight some and mute some
      layer.id = 'verhalen';
      layer.filter = ['all']; 
      layer.paint['circle-color'] = "#dc9104";
      layer.paint['circle-opacity'] = 0.9;
      this.$store.map.addLayer(layer);
      // this.$store.map.setPaintProperty('verhalen_muted', 'circle-color', '#dc9104');
    },

    /**
     * Generate GEOJSON for a project point, containing all related ids as properties
     */
    projectToMapBoxPointFeature(project) {
      let coordinates = project.location;
      let properties = {
        "type": "project",
        "slug": project.slug
      };
      properties['project_'+project.id] = true;
      properties['project_'+project.slug] = true;

      if (project.themas) {
        project.themas.forEach((themaId) => {
          properties['thema_'+themaId] = true;
        })
      }
      if (project.partijen) {
        project.partijen.forEach((partijId) => {
          properties['partij_'+partijId] = true;
        })
      }

      return {
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": [
            coordinates.lng, coordinates.lat
          ]
        },
        "properties": properties
      }
    },
    /**
     * Project Relations, both Thema & Partij lines
     * Colors are set by MapBox based on category property
     */
    addProjectRelations() {
      let features = [];

      let data = this.$store.getters.getThemaList;
      if (data.length !== 0) {
        features = features.concat(data.reduce(this.themaToMapBoxLineFeature, []));
      }
      data = this.$store.getters.getPartijenList;
      if (data.length !== 0) {
        features = features.concat(data.filter((partij) => {
          return partij.type;
        }).reduce(this.partijToMapBoxLineFeature, []));
      }
      if (features.length === 0) {
        return;
      }

      let layer = {
          "id": "connections",
          "type": "line",
          "source": {
              "type": "geojson",
              "data": {
                  "type": "FeatureCollection",
                  "features": features
              }
          },
          "layout": {
              "line-join": "round",
              "line-cap": "round"
          },
          "paint": {
              'line-color': [
                'match',
                ['get', 'category'],
                'thema', '#dc9104',
                'leverancier', '#099a04',
                'kennis', '#045bdc',
                'bouw', '#facf0f',
                'gemeente', '#dc0404',
                'corporatie', '#9f5da4',
                '#D0D1D5'
              ],
              "line-width": 4
          },
          "filter": ['all', ['==', 'type', 'off']]
        };

      this.$store.map.addLayer(layer);
    },
    /**
     * Generate an array of Lines for a Partij
     */
    partijToMapBoxLineFeature(prev, partij) {
      return prev.concat(this.createLineFeatures({
        projects : this.$store.getters.getProjectsByPartij({
          id: partij.id
        }),
        properties: {
          "type": "connection",
          "slug": partij.slug,
          "category": partij.type.toLowerCase()
        }
      }));
    },
    /**
     * Generate an array of Lines for a Thema
     */
    themaToMapBoxLineFeature(prev, thema) {
      return prev.concat(this.createLineFeatures({
        projects : this.$store.getters.getProjectsByThema({
          id: thema.id
        }),
        properties: {
          "type": "connection",
          "slug": thema.slug,
          "category": "thema"
        }
      }));
    },
    /**
     * Takes an array of projects and a set of feature properties
     * For each unique project pair a line is created with those properties attached.
     * Lines are returned as an array
     */
    createLineFeatures({projects, properties}) {
      let result = [];
      let sets = [];
      let projectIds = projects.map((project) => {
        return project.id;
      });

      if (projectIds.length > 1) {
        // console.log(projectIds);
        sets = this.uniquePairs(projectIds);
      }
      if (sets.length === 0) {
        return result;
      }

      let coordinates = this.projectCoordinates;
      for (let i = 0; i < sets.length; i++) {
        let set = sets[i];
        
        // We want a shallow copy
        let propertySet = Object.assign({}, properties);

        propertySet[set[0]] = 'from',
        propertySet[set[1]] = 'to';

        result.push({
          "type" : "Feature",
          "geometry": {
            "type": "LineString",
            "coordinates": [
                coordinates[set[0]],
                coordinates[set[1]]
              ]
            },
          "properties": propertySet
        });
      }

      return result;
    },
    /**
     * When clicked on...
     */
    checkForFeatureOnClick(e) {
      let bbox = [[e.point.x - 5, e.point.y - 5], [e.point.x + 5, e.point.y + 5]];
      let features = this.$store
        .map.queryRenderedFeatures(bbox, {layers: ['verhalen', 'verhalen_muted', 'connections']}); 

      // Nothing to see... 
      if ( ! features.length) {
        return;
      }
      
      // The one and only... 
      let feature = features[0];

      // Is it a project?
      if (
        feature.properties && 
        feature.properties.type === "project" && 
        feature.properties.slug
      ) {
        this.$router.push({ 
          name: 'project-beknopt', 
          params: { slug: feature.properties.slug } 
        })
      }

      // Is it a line? 
      else {
        console.log("YaY", features);
      }
    }
  }
}
</script>

<style lang="scss">
  .mapboxgl-canvas-container, .mapboxgl-canvas {
    &:active, &:focus {
      outline: none;
    }
  }

  .mapboxgl-marker {
    position: absolute;
    cursor: pointer;
  }

  .mapboxgl-map {
    width: 100% !important;
    height: 100% !important;
  }

  // Hide MapBox logo
  .mapboxgl-ctrl.mapboxgl-ctrl-attrib, .mapboxgl-ctrl {
    display: none !important;
  }
  .MapBox {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    user-select: none;
  }
</style>
